import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { useAuth0 } from "@auth0/auth0-react";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const echoRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const initWebSocket = async () => {
      if (!isAuthenticated) return;

      try {
        const token = await getAccessTokenSilently();
        // const host = 'eduprompt-api-dev.cloud-medinnovations.com';
        // const appKey = 'vjn6qs55instbjutvuy8';

        const host = "ittterni-api.eduprompt.it";
        const appKey = "vjn6qs55instbjutvuy8";

        window.Pusher = Pusher;

        echoRef.current = new Echo({
          broadcaster: "reverb",
          key: appKey,
          wsHost: host,
          wsPort: 443,
          wssPort: 443,
          forceTLS: true,
          enabledTransports: ["ws", "wss"],
          authEndpoint: `https://${host}/broadcasting/auth`,
          auth: {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          },
        });

        // ✅ CONNECTION EVENTS
        echoRef.current.connector.pusher.connection.bind("connected", () => {
          console.log("✅ WebSocket initialized");
        });

        echoRef.current.connector.pusher.connection.bind("error", (err) => {
          console.error("❌ WebSocket error:", err);
        });

        echoRef.current.connector.pusher.connection.bind("disconnected", () => {
          console.warn("⚠️ WebSocket disconnected");
        });

        setIsReady(true);
      } catch (error) {
        console.error("WebSocket init error:", error);
      }
    };

    initWebSocket();

    return () => {
      echoRef.current?.disconnect();
      echoRef.current = null;
      setIsReady(false);
    };
  }, [isAuthenticated]);

  const subscribe = (channelName, eventName, callback) => {
    if (!echoRef.current) return;

    const channel = echoRef.current.private(channelName);

    // ✅ Listen for successful subscription
    channel.subscribed(() => {
      console.log(`✅ Subscribed to ${channelName}`);
    });

    // ❌ Listen for subscription error
    channel.error((error) => {
      console.error(`❌ Subscription error on ${channelName}`, error);
    });

    // Listen to your event
    console.log("listening to: ", eventName);
    channel.listen(eventName, callback);

    return channel;
  };

  const leave = (channelName) => {
    if (!echoRef.current) return;
    echoRef.current.leave(channelName);
  };

  return (
    <WebSocketContext.Provider
      value={{
        subscribe,
        leave,
        isReady,
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
